import {legacy_createStore as createStore, applyMiddleware, combineReducers} from 'redux';
import thunk from 'redux-thunk';
// import {createEpicMiddleware, combineEpics} from 'redux-observable';


import {commonReducer} from './common-redux/common.reducers';
import {loginReducer} from './pages/login/login.reducers';
import {reconReducer} from './pages/recon/recon.reducers';
import {reconResultsReducer} from './pages/recon-results/recon-results.reducers';
import {settingsReducer} from './pages/settings/settings.reducers';
import {profileReducer} from './pages/profile/profile.reducers';
import {usersReducer} from './pages/users/users.reducers';
import {databaseReducer} from './pages/database/database.reducers';
import {contextReducer} from './pages/context/context.reducers';
import dataLineage from './pages/data-lineage/data-lineage.reducers';
import lineageReducer from './pages/data-lineage/store/lineageReducer';
import {dataDictionaryReducer} from './pages/data-dictionary/data-dictionary.reducers';
import dataDictionaryViewReducer from './pages/data-dictionary-view/data-dictionary-view.reducers';
import {schemaMonitorReducer} from './pages/schema-monitor/schema-monitor.reducer';
import {workflowReducer} from './pages/workflow/workflow-dashboard.reducers';
import {homeReducer} from './pages/home/home.reducers';
import {myDelegationsReducer} from './pages/my-delegations/my-delegations.reducers';
import {accessAdminReducer} from './pages/access-admin/access-admin.reducers';
import schemaComparisonReducer from './pages/schema-comparison/schema-comparison.reducers';
import dependencyAnalysisReducer from './pages/dependency-analysis/dependency-analysis.reducers';


const rootReducer = combineReducers({
  commonReducer,
  loginReducer,
  reconReducer,
  reconResultsReducer,
  settingsReducer,
  profileReducer,
  usersReducer,
  databaseReducer,
  contextReducer,
  dataLineage,
  lineageReducer,
  dataDictionaryReducer,
  dataDictionaryViewReducer,
  schemaMonitorReducer,
  workflowReducer,
  homeReducer,
  myDelegationsReducer,
  accessAdminReducer,
  schemaComparison: schemaComparisonReducer,
  dependencyAnalysis: dependencyAnalysisReducer,
});


const appStore = createStore(rootReducer, applyMiddleware(thunk));

export default appStore;
